import { render, staticRenderFns } from "./money-tick.vue?vue&type=template&id=3b6101ba&"
import script from "./money-tick.vue?vue&type=script&lang=js&"
export * from "./money-tick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b6101ba')) {
      api.createRecord('3b6101ba', component.options)
    } else {
      api.reload('3b6101ba', component.options)
    }
    module.hot.accept("./money-tick.vue?vue&type=template&id=3b6101ba&", function () {
      api.rerender('3b6101ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/money-tick.vue"
export default component.exports